export const firebaseConfig = {
  apiKey: "AIzaSyDXNik3DqtHX9ZSHOeJoz3QC0OuXq3TZCo",
  authDomain: "life-cycle-9ae8b.firebaseapp.com",
  databaseURL:
    "https://life-cycle-9ae8b-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "life-cycle-9ae8b",
  storageBucket: "life-cycle-9ae8b.appspot.com",
  messagingSenderId: "757328581454",
  appId: "1:757328581454:web:5754ec0a65c3a20c64441f",
};
